import React from 'react';
import PropTypes from 'prop-types';

const sizes = {
  small: ['16px', '16px'],
  middle: ['24px', '24px'],
  large: ['32px', '32px'],
  huge: ['64px', '64px'],
};

const DoneIcon = (props) => {
  const width = sizes[props.size][0];
  const height = sizes[props.size][1];

  const style = {};
  if (props.shouldPadding) {
    style.padding = '4px';
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 50 50"
      stroke="currentColor"
      strokeWidth={2}
      width={width}
      height={height}
      style={style}
    >
      <path d="M42.875 8.625a.88.88 0 0 0-.094.031 1.011 1.011 0 0 0-.625.469L21.72 40.813 7.656 28.124a.997.997 0 0 0-1.773.473.998.998 0 0 0 .46.996l14.907 13.5a.999.999 0 0 0 1.5-.219l21.094-32.688a1 1 0 0 0-.969-1.562Z" />
    </svg>
  );
};

DoneIcon.defaultProps = {
  size: 'middle',
  shouldPadding: false,
};

DoneIcon.propTypes = {
  size: PropTypes.oneOf(['small', 'middle', 'large', 'huge']),
  shouldPadding: PropTypes.bool,
};

export default DoneIcon;
